import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormalizeCandidate, FormalizeCompany, FormalizeJobMatch, FormalizeRequisition } from 'src/app/public/app/models/formalizePayload';
import { CompanyService } from 'src/app/core/services/company.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { MeetingService } from 'src/app/core/services/meeting.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-conference',
  templateUrl: './conference.component.html',
  styleUrls: ['./conference.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ConferenceComponent implements OnInit {

  //bindings
  @Input() scheduleId: string;
  @Input() candidateId: string;
  @Input() jobId: string;
  @Input() jobMatchId: string;
  @Input() workflowStep: string;
  @Input() type: string;
  @Input() mode: string;

  isLoading: boolean;
  context: any;
  displayAllSchedule: boolean;
  companyId: any;
  isCorporate: any;
  participantName: string;
  isLoadingMeetingLink: boolean;
  scheduleInfo: any;
  candidateJobMatch: any;
  formalizeActivityPayload: any;
  // Referenced in the original controller/template but never assigned (pre-existing
  // dead/undefined reference from the AngularJS controller, preserved as-is for 1:1
  // behavior, matching the precedent in audio-video-conference.component.ts).
  meetingLink: any;

  constructor(
    private authService: AuthService,
    private companyService: CompanyService,
    private jobMatchService: JobMatchService,
    private meetingService: MeetingService,
    private alertsAndNotificationsService: AlertAndNotificationsService
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this._setContext();
    this.companyId = this.authService.userDetails.company.companyId;
    this.isCorporate = this.companyService.isCorporateCompany();
    this.participantName = this.authService.userDetails.firstname + ' ' + this.authService.userDetails.lastname;

    this.isLoadingMeetingLink = true;

    if (this.context !== 'candidateCard') {
      if (this.scheduleId) {
        this._getScheduledMeetingDetails((data) => {
          this._getCandidateJobMatchInfo(() => {
            this.scheduleInfo = this.meetingService.getMassagedMeetingDetails(data);
            this.isLoading = false;
          }, error => {
            this.isLoading = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
          });
        });
      } else if (this.workflowStep == 'rs') {
        this._getCandidateJobMatchInfo(() => {
          this.isLoading = false;
        }, error => {
          this.isLoading = false;
          this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
      }
    }
  }

  _setContext() {
    if (this.jobMatchId) {
      this.context = "candidateJobMatchCard";
    } else if (this.candidateId) {
      this.context = "candidateCard";
      this.isLoading = false;
    } else {
      this.context = "schedule";
    }

    this.displayAllSchedule = false;
    if (this.jobMatchId && (this.workflowStep === 'ps' || this.workflowStep == 'in')) {
      this.displayAllSchedule = true;
    }
  }

  _getCandidateJobMatchInfo(successCallback, errorCallback) {
    this.isLoading = true;
    this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, (data) => {
      this.candidateJobMatch = data;
      this.candidateJobMatch.name = data.firstName + ' ' + data.lastName;
      this.candidateId = data.id;
      this.jobId = data.jobMatchJobId;
      this.setFormalizeActivityPayload();
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      if (errorCallback) {
        errorCallback();
      }
    }, undefined);
  }

  _getScheduledMeetingDetails(successCallback) {
    this.jobMatchService.getMeetingDetails(this.scheduleId, (data) => {
      this.candidateId = data.candidateDetail.id;
      this.jobId = data.jobId;
      this.jobMatchId = data.jobMatchId;
      if (successCallback) {
        successCallback(data);
      }
    }, (error) => {
      this.isLoading = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  setFormalizeActivityPayload() {
    this.formalizeActivityPayload = {
      candidate: new FormalizeCandidate(this.candidateId, this.candidateJobMatch.firstName, this.candidateJobMatch.lastName),
      requisition: new FormalizeRequisition(this.jobId, this.candidateJobMatch.jobMatchRequisitionNum, this.candidateJobMatch.jobMatchTitle),
      jobMatch: new FormalizeJobMatch(this.candidateJobMatch.jobMatchId, this.jobId, this.candidateJobMatch.jobMatchRequisitionNum, this.candidateJobMatch.jobMatchTitle),
      company: new FormalizeCompany(this.companyId, this.candidateJobMatch.currentJobCompanyName, this.candidateJobMatch.clientOrBUId, this.candidateJobMatch.clientOrBUName)
    };
  }
}
